import { createReducer } from 'redux-create-reducer'
import type { TempItem } from 'types/shortlist'
import {
  TRACKS_UPLOADER_RESET,
  TRACKS_UPLOADER_SAVE_SUCCESS,
  TRACKS_UPLOADER_SET,
  TRACKS_UPLOADER_UPLOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
const initialState = {
  tempItem: null,
}
export type TrackUploaderState = {
  tempItem: TempItem | null | undefined
  uploadedToS3?: boolean
  filename?: string | null | undefined
  needsFinalizeUpload?: boolean | null | undefined
  uploadPolicy?: string | null | undefined
  filesize?: number | null | undefined
}
export const trackUploaderReducer = createReducer<TrackUploaderState, any>(
  initialState,
  {
    [TRACKS_UPLOADER_SET](state, action) {
      return {
        ...state,
        uploadedToS3: false,
        filename: null,
        needsFinalizeUpload: null,
        uploadPolicy: null,
        tempItem: action.track,
      }
    },

    [TRACKS_UPLOADER_UPLOAD_SUCCESS](state, action) {
      return {
        ...state,
        uploadedToS3: true,
        filename: action.filename,
        needsFinalizeUpload: action.needsFinalizeUpload,
        uploadPolicy: action.uploadPolicy,
        filesize: action.filesize,
      }
    },

    [TRACKS_UPLOADER_RESET](state) {
      return {
        ...state,
        uploadedToS3: false,
        filename: null,
        needsFinalizeUpload: null,
        uploadPolicy: null,
        tempItem: null,
        filesize: null,
      }
    },

    [TRACKS_UPLOADER_SAVE_SUCCESS](state) {
      return {
        ...state,
        uploadedToS3: false,
        filename: null,
        needsFinalizeUpload: null,
        uploadPolicy: null,
        tempItem: null,
      }
    },
  },
)
